export default "/assets/images/home-wrecker3.34e9e14aa4ab68b0.png";